/* eslint-disable react/display-name */
import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { Container, Button, Box } from '@mui/material';
import DataTable from 'react-data-table-component';
import Header from '../components/Headers/Header';
import { orderCustomStyles } from '../utils/tableForOutFOrDeliveryReportDetails';
import useGlobalStyles from '../utils/globalStyles';

const AssignRiderResultPage = (props) => {
    const { t, history } = props;
    const globalClasses = useGlobalStyles();

    const [allAssignedOrders, setAllAssignedOrders] = useState([]);
    const [allUnassignedOrders, setAllUnassignedOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const adminLockRiderResult = JSON.parse(localStorage.getItem("adminLockOrderResults"));
        if (adminLockRiderResult) {
            setAllAssignedOrders(adminLockRiderResult.assignedOrders || []);
            setAllUnassignedOrders(adminLockRiderResult.unassignedOrders || []);
        }
        setLoading(false);
    }, []);

    const orderColumns = [
        { name: 'Order ID', selector: row => row._id.slice(-5) },
        { name: 'Customer Name', selector: row => row.customerName || 'N/A', style: { minWidth: "150px" } },
        { name: 'Customer Phone', selector: row => row.customerPhone || 'N/A', style: { minWidth: "150px" } },
        { name: 'Delivery Date', selector: row => row.deliveryDate, style: { minWidth: "120px" } },
        {
            name: "Delivery Address",
            cell: row => {
                const details = row.deliveryAddress && row.deliveryAddress.details ? row.deliveryAddress.details : "N/A";
                const address = row.deliveryAddress && row.deliveryAddress.deliveryAddress ? row.deliveryAddress.deliveryAddress : "N/A";
                return details + ", " + address;
            },
            style: { minWidth: "300px", textAlign: 'left' },
        },
        { name: 'Locked Rider', selector: row => row.lockedRiderEmail || 'Not Assigned', style: { minWidth: "200px" } },
        { name: 'Amount', selector: row => row.orderAmount, style: { minWidth: "100px" } },
    ];

    const downloadCSV = () => {
        const csvRows = [];
        const headers = ['Order ID', 'Customer Name', 'Customer Phone', 'Delivery Date', 'Delivery Address', 'Order Amount', 'Locked Rider Email'];

        const escapeCsvValue = (value) => `"${String(value || '').replace(/"/g, '""')}"`;

        const formatAddress = (addr) => {
            if (addr && addr.details && addr.deliveryAddress) {
                return addr.details + ", " + addr.deliveryAddress;
            } else if (addr && addr.details) {
                return addr.details;
            } else if (addr && addr.deliveryAddress) {
                return addr.deliveryAddress;
            } else {
                return "N/A";
            }
        };

        // Assigned Orders
        csvRows.push('Assigned Orders');
        csvRows.push(headers.join(','));
        allAssignedOrders.forEach(order => {
            csvRows.push([
                escapeCsvValue(order._id),
                escapeCsvValue(order.customerName),
                escapeCsvValue(order.customerPhone),
                escapeCsvValue(order.deliveryDate),
                escapeCsvValue(formatAddress(order.deliveryAddress)),
                escapeCsvValue(order.orderAmount),
                escapeCsvValue(order.lockedRiderEmail)
            ].join(','));
        });

        // Unassigned Orders
        csvRows.push('\nUnassigned Orders');
        csvRows.push(headers.join(','));
        allUnassignedOrders.forEach(order => {
            csvRows.push([
                escapeCsvValue(order._id),
                escapeCsvValue(order.customerName),
                escapeCsvValue(order.customerPhone),
                escapeCsvValue(order.deliveryDate),
                escapeCsvValue(formatAddress(order.deliveryAddress)),
                escapeCsvValue(order.orderAmount),
                escapeCsvValue('Not Assigned')
            ].join(','));
        });

        const csvContent = `data:text/csv;charset=utf-8,${csvRows.join('\n')}`;
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'assigned_and_unassigned_orders.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleBack = () => {
        history.push('/local_admin/Manageriders');
        localStorage.removeItem('adminLockOrderResults');
    };

    return (
        <>
            <Header />
            <Container className={globalClasses.flex} fluid>
                <Box sx={{ textAlign: 'right', mb: 3 }}>
                    <Button 
                        onClick={downloadCSV} 
                        className={globalClasses.dashbordBtn}
                        disabled={allAssignedOrders.length === 0 && allUnassignedOrders.length === 0}
                    >
                        Download CSV
                    </Button>
                    <Button onClick={handleBack} className={globalClasses.dashbordBtn}>Back</Button>
                </Box>
                {loading ? (
                    <p>Loading...</p>
                ) : allAssignedOrders.length > 0 || allUnassignedOrders.length > 0 ? (
                    <>
                        <br />
                        <DataTable
                            keyField="_id"
                            customStyles={orderCustomStyles}
                            title="Assigned Orders"
                            columns={orderColumns}
                            data={allAssignedOrders}
                            pagination
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                        />
                        <br />
                        <DataTable
                            keyField="_id"
                            customStyles={orderCustomStyles}
                            title="Unassigned Orders"
                            columns={orderColumns}
                            data={allUnassignedOrders}
                            pagination
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                        />
                    </>
                ) : (
                    <p>No order details found for the last assignment.</p>
                )}
            </Container>
        </>
    );
};

export default withTranslation()(AssignRiderResultPage);
